<template>
  <q-card style="min-width: 60vw">
    <q-card-section class="row items-center bg-grey-3">
      <span class="text-subtitle1 text-bold">调整信息</span>
      <q-space />

      {{ question.row.code }}
      {{ question.row._q }}
    </q-card-section>
    <q-card-section class=" bg-yellow-3 q-ma-md " style="font-size: 0.8rem">
      <ul class="q-mb-sm">
        请先检查问题代号是否正确，在修改值时，显示数据原始格式（JSON）, 请不要删除无关的符号，其中<br/>
      </ul>
      <li  class="q-mb-sm">
        <span class="bg-red-2 rounded-borders q-py-xs q-px-sm text-red-8">code</span>
        ：表示问题答案的序号，如需修改请参考纸质版问卷。
      </li>
      <li  class="q-mb-sm">
       <span class="bg-red-2 rounded-borders q-py-xs q-px-sm text-red-8">value</span>
        ：表示问题答案的值，如需修改请参考纸质版问卷。
      </li>
      此外，出现多个 code 则表示答案可能是多选。
    </q-card-section>
    <q-card-section class="row items-center">
      <div class="col">
        <q-input v-model="qCode" type="text" label="输入问题代号" />

        <q-input
          type="textarea"
          style="white-space: pre-wrap"
          v-model="qAnswer"
          label=" 输入修改后的值（输入框内展示为原始数据）"
        />
        <span class="text-grey-6">输入框内展示为原始数据，如需查看当前提交，可关闭当前对话框，点击 「眼睛」图标</span>
      </div>
    </q-card-section>
    <q-card-actions align="right">
      <q-btn flat color="primary" v-close-popup> 取消 </q-btn>
      <q-btn color="primary" @click="submitChanges"> 提交 </q-btn>
    </q-card-actions>
  </q-card>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      defalut: {},
    },
  },
  data() {
    return {
      qCode: "",
      qAnswer: "",
    };
  },

  mounted() {
    // console.log("ss", this.question);
    this.qCode = this.question.row.code;
    this.qAnswer = JSON.stringify(this.question.row.answer, undefined, 2);
  },

  methods: {
    submitChanges() {
      // // this.question.row.code = this.qAnswer
      // console.log('pushUpdateAnswerArrary')
      // console.log(this.qAnswer)
      try {
        const newAnswer = JSON.parse(this.qAnswer);
        this.$emit("pushUpdateAnswerArrary", { [this.qCode]: newAnswer });
      } catch (error) {
        this.$q.notify({
          type: "danger",
          message: "填入信息有误，请检查信息",
        });
      }
    },
  },
};
</script>

<style>
</style>